import Rota from './Rota';

export default Rota;
